import m from 'mithril';
import app from '../app';

const api = {
	get: async (endPoint, data = {}, secure = true) => {
		try {
			const url = app.apiRoot + endPoint;
			const method = 'GET';

			let headers = {
				Accept: 'application/json',
			};

			// if (secure === true) {
			//     headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
			// }

			const body = data;

			return await request(url, method, headers, body);
		} catch (err) {
			return false;
		}
	},

	post: async (endPoint, data = {}, secure = true) => {
		try {
			const url = app.apiRoot + endPoint;
			const method = 'POST';

			let headers = {
				Accept: 'application/json',
			};

			// if (secure === true) {
			//     headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
			// }

			const body = data;

			return await request(url, method, headers, body);
		} catch (err) {
			return false;
		}
	},
};

const request = async (url, method, headers, body, timeout = 5000) => {
	try {
		let result = await m.request({
			url: url,
			method: method,
			timeout: timeout,
			headers: headers,
			body: body,
		});

		if (result.success === true) {
			return result.data;
		} else {
			return false;
		}
	} catch (error) {
		return false;
	}
};

export default api;
